import * as actions from './sourceApplicationActions'
import { Map } from 'immutable'

const initialState = Map({
  loading: false,
  error: false,
  sent: false,
})

function sourceApplication(state = initialState, action) {
  switch (action.type) {
    case actions.SEND_SOURCE_APPLICATION:
      return state.set('loading', true)

    case actions.SEND_SOURCE_APPLICATION_SUCCESS:
      return state
        .set('loading', false)
        .set('sent', true)
        .set('error', false)

    case actions.SEND_SOURCE_APPLICATION_FAILURE:
      return state
        .set('loading', false)
        .set('error', true)

    default:
      return state
  }
}

export default sourceApplication
